import React from 'react';
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useQuery } from 'react-query';
import { getAllTags } from '../../../services/file-explorer/fileExplorerApi';
import { useTranslate } from 'ra-core';

export default function TagField(props) {
    const { filterTags, setFilterTags } = props;
    const translate = useTranslate();
    const { data } = useQuery('/file-explorer/tag', getAllTags);

    let tags = Array.prototype.concat.apply([], data?.map(function (tagGroup) {
        const groupTags = tagGroup.tags?.map(function (tag) {
            return {
                id: tag.id,
                name: tag.name,
                group: tagGroup.name
            };
        });
        return groupTags;
    }) ?? []);

    return (
        <Autocomplete
            fullWidth={true}
            multiple
            options={tags}
            groupBy={(tag) => tag.group}
            getOptionLabel={(option) => option.name}
            getOptionSelected={ (option, value) => option.id == value.id }
            renderInput={(params) => <TextField {...params} label={translate(`cmss.resources.file-explorer.tags.name`)} variant="outlined" />}
            onChange={(event, value) => setFilterTags(value) }
            value={filterTags}
        />
    );
}